var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9983 121.143C95.5574 121.143 121.141 95.5594 121.141 64.0003C121.141 32.4411 95.5574 6.85742 63.9983 6.85742C32.4392 6.85742 6.85547 32.4411 6.85547 64.0003C6.85547 95.5594 32.4392 121.143 63.9983 121.143Z",
    fill: "#84C70D",
    fillOpacity: 0.2,
    stroke: "#84C70D",
    strokeWidth: 13.7143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1406 69.714L57.764 86.8569C65.5863 64.3866 72.1009 54.5265 86.8549 41.1426",
    stroke: "#84C70D",
    strokeWidth: 13.7143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleValidation);
export default __webpack_public_path__ + "static/media/check-circle-validation.3dc5b11c2293f4ac30cd6f055c021092.svg";
export { ForwardRef as ReactComponent };